import { formatInTimeZone } from 'date-fns-tz';
import { toISO8601String } from './tzNormalization';

export function formatDate(date: Date, tz: string, formatString: string) {
    return formatInTimeZone(toISO8601String(date), tz, formatString);
}
